define([
    "./hereMapsModule"
], function (hereMapsModule) {
    "use strict";

    return hereMapsModule.service("hereMapsRectangleSelectionService", [
        "hereMapsService",
        "carrierDrawingCommonService",
        function (hereMapsService,
                  carrierDrawingCommonService) {
            var Here = null;
            var map = null;
            var behavior = null;

            var onCompleteCallback = null;
            var startGeoPoint = null; // Guarda o primeiro clique
            var pointerDown = null; // Guarda a posição de descida do mouse para validar se foi um clique limpo
            var selectionRect = null;
            var currentMode = null;

            // Eventos
            var pointerDownEvent = null;
            var pointerUpEvent = null;
            var pointerMoveEvent = null;

            return {
                startSelection: startSelection,
                cancelDrawing: cancelSelection
            };

            function startSelection(callback) {
                onCompleteCallback = callback;

                Here = hereMapsService.getHere();
                map = hereMapsService.getMap();
                behavior = hereMapsService.getBehavior();

                hereMapsService.getBehavior().disable(
                    Here.mapevents.Behavior.Feature.PANNING
                );

                carrierDrawingCommonService.setCursor(true);

                // pointerDown: ancora o primeiro ponto (startGeoPoint) e já cria o retângulo fantasma
                pointerDownEvent = function (event) {
                    if (event.currentPointer.button !== 0) {
                        return;
                    }

                    pointerDown = {
                        x: event.currentPointer.viewportX,
                        y: event.currentPointer.viewportY
                    };

                    if (!startGeoPoint) {
                        startGeoPoint = map.screenToGeo(pointerDown.x, pointerDown.y);
                        createSelectionRect(startGeoPoint);
                    }
                };

                // pointerMove (mouse solto) / drag (mouse pressionado): atualiza o retângulo fantasma
                // e detecta se virou um arraste real (DRAG), quando disparado via "drag"
                pointerMoveEvent = function (event) {
                    if (!startGeoPoint || !selectionRect) {
                        return;
                    }

                    var currentGeoPoint = map.screenToGeo(
                        event.currentPointer.viewportX,
                        event.currentPointer.viewportY
                    );

                    if (pointerDown) {
                        var currentMove = {
                            x: event.currentPointer.viewportX,
                            y: event.currentPointer.viewportY
                        };

                        // Distância percorrida com o botão ainda pressionado: acima do limite = está arrastando
                        var distance = carrierDrawingCommonService.getPixelDistance(currentMove, pointerDown);
                        if (!carrierDrawingCommonService.isValidTap(distance)) {
                            currentMode = "DRAG";
                        }
                    }

                    selectionRect.setBoundingBox(buildGeoRect(startGeoPoint, currentGeoPoint));
                };

                // pointerUp: finaliza se veio de um DRAG, ou aplica a regra do clique-clique (TAP)
                pointerUpEvent = function (event) {
                    if (!pointerDown) {
                        return;
                    }

                    if (event.currentPointer.button !== 0) {
                        pointerDown = null;
                        return;
                    }

                    var pointerUp = {
                        x: event.currentPointer.viewportX,
                        y: event.currentPointer.viewportY
                    };

                    var distance = carrierDrawingCommonService.getPixelDistance(pointerUp, pointerDown);
                    pointerDown = null;

                    var tapGeoPoint = map.screenToGeo(pointerUp.x, pointerUp.y);

                    if (currentMode === "DRAG") {
                        return finishedSelection(tapGeoPoint);
                    }

                    // Não é DRAG: só segue se essa soltura também foi um clique limpo (TAP)
                    if (!carrierDrawingCommonService.isValidTap(distance)) {
                        return; // Ignora arrastes
                    }

                    if (currentMode === "TAP") {
                        return finishedSelection(tapGeoPoint);
                    }
                    currentMode = "TAP";
                };

                map.addEventListener("pointerdown", pointerDownEvent);
                map.addEventListener("pointermove", pointerMoveEvent);
                map.addEventListener("drag", pointerMoveEvent);
                map.addEventListener("pointerup", pointerUpEvent);
            }

            function finishedSelection(tapGeoPoint) {
                if (!startGeoPoint) {
                    return;
                }

                var finalGeoRect = buildGeoRect(startGeoPoint, tapGeoPoint);
                var callback = onCompleteCallback;

                callback(finalGeoRect);
                cleanup();

                startSelection(callback); // permite desenhar o próximo retângulo em seguida
            }

            function cancelSelection() {
                cleanup(); // Limpa os eventos, desativa cursores e remove o retângulo fantasma
                onCompleteCallback = null;
            }

            function cleanup() {
                removeSelectionRect();

                if (!pointerDownEvent || !pointerUpEvent || !pointerMoveEvent) {
                    return;
                }

                if (map) {
                    map.removeEventListener("pointerdown", pointerDownEvent);
                    map.removeEventListener("pointerup", pointerUpEvent);
                    map.removeEventListener("pointermove", pointerMoveEvent);
                    map.removeEventListener("drag", pointerMoveEvent);
                }

                if (behavior) {
                    carrierDrawingCommonService.setCursor(false);
                    behavior.enable(
                        Here.mapevents.Behavior.Feature.PANNING
                    );
                }

                startGeoPoint = null;
                pointerDown = null;
                selectionRect = null;
                currentMode = null;
            }

            function createSelectionRect(geoPoint) {
                var initialBox = buildGeoRect(geoPoint, geoPoint);
                selectionRect = new Here.map.Rect(initialBox, {
                    style: {
                        strokeColor: "rgba(54, 105, 115, 1)",
                        fillColor: "rgba(78, 203, 205, 0.8)",
                        lineWidth: 2
                    },
                    volatility: true
                });
                map.addObject(selectionRect);
            }

            function removeSelectionRect() {
                if (selectionRect && map) {
                    map.removeObject(selectionRect);
                    selectionRect = null;
                }
            }

            // Cria a Bounding Box correta, indiferente da direção em que o usuário move o mouse
            function buildGeoRect(pointA, pointB) {
                return new Here.geo.Rect(
                    Math.max(pointA.lat, pointB.lat),
                    Math.min(pointA.lng, pointB.lng),
                    Math.min(pointA.lat, pointB.lat),
                    Math.max(pointA.lng, pointB.lng)
                );
            }
        }
    ]);
});